import { render, staticRenderFns } from "./ResponsibleGaming.vue?vue&type=template&id=9516e366&scoped=true"
import script from "./ResponsibleGaming.vue?vue&type=script&lang=js"
export * from "./ResponsibleGaming.vue?vue&type=script&lang=js"
import style0 from "./ResponsibleGaming.vue?vue&type=style&index=0&id=9516e366&prod&lang=scss&scoped=true"
import style1 from "./ResponsibleGaming.vue?vue&type=style&index=1&id=9516e366&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_40df3e800382af9a7a59c1fe33ba5098/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9516e366",
  null
  
)

export default component.exports